module.exports = __webpack_public_path__ + "static/img/IMG_20240903_193050.5122cf3f.jpg";